var map = {
	"./icon-element-Anemo.webp": "3523",
	"./icon-element-Bow.webp": "0e1d",
	"./icon-element-Catalyst.webp": "1966",
	"./icon-element-Claymore.webp": "269b",
	"./icon-element-Cryo.webp": "d724",
	"./icon-element-Dendro.webp": "74d7",
	"./icon-element-Electro.webp": "ca5a",
	"./icon-element-Geo.webp": "9a7f",
	"./icon-element-Hydro.webp": "780c",
	"./icon-element-Polearm.webp": "e6c6",
	"./icon-element-Pyro.webp": "a6d2",
	"./icon-element-Sword.webp": "8d85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c10e";